import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import RssFeedOutlinedIcon from '@material-ui/icons/RssFeedOutlined';
import DoneAllOutlinedIcon from '@material-ui/icons/DoneAllOutlined';
import SubjectOutlinedIcon from '@material-ui/icons/SubjectOutlined';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    divider: {
        backgroundColor: `black`
    },
    collapseIcon: {
        color: `black`,
        padding: `18px`
    }
}));

const Sidebar = ({ handleSideMenuClose, openSideMenu }) => {
    const classes = useStyles();
    //const [open, setOpen] = useState([false]);

    //const handleClick = (index) => {
    //    let updatedOpen = { ...open };
    //    updatedOpen[index] = !updatedOpen[index];
    //    setOpen(updatedOpen);
    //};

    return (
        <Drawer
            className=""
            variant="persistent"
            anchor="left"
            open={openSideMenu}
            classes={{
                paper: "sidebar",
            }}
        >
            <div>
                <IconButton onClick={handleSideMenuClose} className={classes.collapseIcon}>
                    <ChevronLeftIcon />
                </IconButton>
            </div>
            <Divider className={classes.divider} />
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                className={classes.root}
            >
                <Link to={"/home"}>
                    {/*<ListItem button onClick={() => { handleClick(0); }}>*/}
                    <ListItem button>
                        <ListItemIcon>
                            <RssFeedOutlinedIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Requests Feed" />
                    {/*{open[0] ? <ExpandLess /> : <ExpandMore />}*/}
                    </ListItem>
                </Link>
                {/*<ListItem button>
                    <ListItemIcon>
                        <SubjectOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Applied Offers" />
                </ListItem>
                <ListItem button>
                    <ListItemIcon>
                        <DoneAllOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Accepted Offers" />
                </ListItem>
                <Collapse in={open[0]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <Link to={"/home/flight"} onClick={handleSideMenuClose}>
                            <ListItem button className={classes.nested}>
                                <ListItemIcon>
                                    <FlightIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary="Flights" />
                            </ListItem>
                        </Link>
                        <ListItem button className={classes.nested}>
                            <ListItemIcon>
                                <LocationCityOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="Hotels" />
                        </ListItem>
                        <ListItem button className={classes.nested}>
                            <ListItemIcon>
                                <InsertDriveFileOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="Visa" />
                        </ListItem>
                        <ListItem button className={classes.nested}>
                            <ListItemIcon>
                                <DirectionsBusOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="Transportation" />
                        </ListItem>
                        <ListItem button className={classes.nested}>
                            <ListItemIcon>
                                <HowToRegOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary="Registrations" />
                        </ListItem>
                    </List>
                </Collapse>*/}
            </List>
        </Drawer>
    )
}

export default Sidebar;